// extracted by mini-css-extract-plugin
module.exports = {"location":"style_location__F2Jjd","thumbnailContainer":"style_thumbnailContainer__v5Ed2","thumbnailIcon":"style_thumbnailIcon__xSRka"};